import axios from "axios";

const normalizeApiBaseUrl = (raw) => {
  const fallback = "http://localhost:5001/api";
  const value = String(raw || "").trim();
  if (!value) return fallback;
  const withoutTrailingSlash = value.replace(/\/+$/, "");
  if (withoutTrailingSlash.endsWith("/api")) return withoutTrailingSlash;
  return `${withoutTrailingSlash}/api`;
};

const API = axios.create({
  baseURL: normalizeApiBaseUrl(process.env.REACT_APP_API_URL)
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default API;
